import { render, staticRenderFns } from "./TestTabNewTest.vue?vue&type=template&id=c13cd6ee&"
import script from "./TestTabNewTest.vue?vue&type=script&lang=js&"
export * from "./TestTabNewTest.vue?vue&type=script&lang=js&"
import style0 from "./TestTabNewTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TestTabNewTest.vue"
export default component.exports